module.exports = __webpack_public_path__ + "assets/img/elem6-ability2.4656872a.gif";